import http from 'plugins/axios';

export default {

    baseConfig() {
        return http.get({
            url: '/admin/redEnvelope/baseConfig',
        });
    },

    baseConfigUpdate(data) {
        return http.post({
            url: '/admin/redEnvelope/baseConfigUpdate',
            data,
        });
    },

    updateRed(data) {
        return http.post({
            url: '/admin/redEnvelope/update',
            data,
        });
    },

    createRed(data) {
        return http.post({
            url: '/admin/redEnvelope/create',
            data
        });
    },

    redInfoById(data) {
        return http.get({
            url: '/admin/redEnvelope/info',
            data
        });
    },

    redList(data) {
        return http.get({
            url: '/admin/redEnvelope/list',
            data
        });
    },

    receiveList(data) {
        return http.get({
            url: '/admin/redEnvelope/receiveList',
            data
        });
    },

    audit(data) {
        return http.post({
            url: '/admin/redEnvelope/audit',
            data,
            dataType: 'form'
        });
    },

    redEnvelopeList(data) {
        return http.get({
            url: '/admin/redEnvelope/redEnvelopeList',
            data
        });
    }
}
